export default "__VITE_ASSET__DM7c5Py5__"